const DOM = {};

const cacheDOM = () => {
    DOM.filterButton = document.querySelector('.search__filter');
    DOM.filterBox = document.querySelector('.search-filters__filter-box');
    DOM.filterOptions = document.querySelectorAll('.search-filters__label');
};

const showFilters = () => {
    if (DOM.filterBox.style.display) {
        DOM.filterBox.removeAttribute('style');
        DOM.filterButton.classList.remove('open');
    } else {
        DOM.filterBox.style.display = 'block';
        DOM.filterButton.classList.add('open');
    }
};

const filterByTag = (option) => {
    const className = 'search-filters__label--selected';
    if (!option.classList.contains(className)) {
        option.classList.add(className);
    } else {
        option.classList.remove(className);
    }
};

const handleFilter = (e) => {
    filterByTag(e.target);
};

const bindEvents = () => {
    if (DOM.filterButton) {
        DOM.filterButton.addEventListener('click', showFilters);
    }
    DOM.filterOptions.forEach((option) => {
        option.addEventListener('click', handleFilter);
    });
};

const init = () => {
    cacheDOM();
    bindEvents();
};

const searchBarFilter = { init };
export default searchBarFilter;
